export const UPDATE_ACCOUNT_PROFILE_FUNC = 'updateAccount';



// WEBPACK FOOTER //
// ./src/common/constants/profile-func.constants.ts